import { getDealershipsByGroup } from "../api/endpoints/dealership/request";
import { LocationType } from "../pages/Appointment/AppointmentContent";
import { filterDealerships, getDealershipData } from "./dealership-utils";
import { getGroupId, GroupIds } from "./group-utils";

interface GetLatitudeAndLongitudeProps {
  postCode: string;
  setLocation?: (props: any) => void;
  setPostCodeError?: (props: any) => void;
  setButtonClicked?: (props: any) => void;
}

 const awaitGoogleMaps = () => {
  return new Promise<void>((resolve) => {
    setInterval(() => {
      if (window.google && window.google.maps) {
        resolve()
      }
    }, 100)
  })
}

export const getLatitudeAndLongitude = async ({
  postCode,
  setLocation,
  setPostCodeError,
  setButtonClicked,
}:GetLatitudeAndLongitudeProps) => {
  await awaitGoogleMaps()
  let geocodeService: any

  return new Promise((resolve, reject) => {
    if (!geocodeService) {
      geocodeService = new window.google.maps.Geocoder()
    }

    geocodeService.geocode(
      {
        address: postCode,
        componentRestrictions: {
          country: "uk",
          postalCode: postCode,
        },
      },
      (placeInfo: any) => {
        if (placeInfo && placeInfo.length !== 0 && placeInfo[0].geometry) {
          const latitude = placeInfo[0].geometry.location.lat()
          const longitude = placeInfo[0].geometry.location.lng()

          const location = {
            latitude,
            longitude,
          }

          resolve({
            latitude,
            longitude,
          })
          if (postCode && setLocation) {
            setLocation(location)
          }
        }
        if (!placeInfo) {
          setPostCodeError && setPostCodeError(true)
          setButtonClicked && setButtonClicked(false)
        } else {
          setPostCodeError && setPostCodeError(false)
          setButtonClicked && setButtonClicked(false)
        }
      }
    )
  })
}

export const getClosestDealerships = async (groupId: string, latAndLong: LocationType, brand?: string) => {
  const group = groupId && groupId.length > 0  ? groupId : GroupIds[1]
  
  let getDealerships
  getDealerships = await getDealershipsByGroup(latAndLong, group, brand)
  if (getDealerships.data?.Dealerships.length === 0) {
    getDealerships = await getDealershipsByGroup(latAndLong, group)
  }

  const dealerships = getDealerships.data?.Dealerships ?? null

  let sortedDealerships;
  
  if (dealerships) {      
    const currentGroupId = getGroupId(parseInt(group))
    const filteredDealerships = filterDealerships(dealerships, currentGroupId)
    const dealershipData = getDealershipData(
      filteredDealerships,
      currentGroupId,
      latAndLong
    )

    const convertedMilesToNumber = dealershipData?.map((d) => ({...d, Distance: Number(d.Distance?.replace("miles", ""))}))
    const sortedDealershipsByDistance = convertedMilesToNumber.sort((a,b) => a.Distance - b.Distance)
    const dealershipArray = sortedDealershipsByDistance.map((d) => ({ ...d, Distance: `${d.Distance.toString()} miles`}))

    sortedDealerships = dealershipArray;
  }

  return sortedDealerships;
}